import { cloneDeep } from 'lodash'
import Cookies from 'universal-cookie'
import moment from 'moment-timezone'
const dateOnly = 'DDMMMYY'
const cookies = new Cookies()

const getAwbs = (record, priorityData = []) => {
  let data = cloneDeep(record)
  let awbsIn = []

  data.ulds_out && data.ulds_out.map(uld => {
    uld.awbs_in && uld.awbs_in?.map(awb => {
      if (cookies.get('station') != awb?.dest) {
        let pcs = awb.avl_pcs || 0
        const index = awbsIn.findIndex(x => x.awb_no === awb.awb_no)
        if (index == -1) {
          awbsIn.push({
            ...awb,
            pcs: pcs,
            total_pcs: awb?.awb?.pcs?.total?.value || pcs,
            id: null,
            ids: [awb.id],
            is_assigned: true,
            on_hand: true,
            pre_build: false,
            ch_wgt: {
              unit: awb?.awb?.weight_unit,
              value: awb?.awb?.ch_pcs * (pcs || 0)
            },
            pri: priorityData?.find(x => x.p_code == awb?.prod_code)?.priority || null,
            sort_priority: priorityData?.find(x => x.p_code == awb?.prod_code)?.sort_priority || null,
            delay: awb?.awb?.time_of_avl ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment.utc(awb?.awb?.time_of_avl).tz(cookies.get('timezone')), 'days') : 0,
            vol: {
              value: parseFloat(awb?.awb?.vol_pcs) * (pcs || 0),
              unit: awb?.awb?.vol_unit
            },
            comment: awb?.segs_out?.allotment,
            at_stn: [
              {
                blk: uld?.blk || false,
                uld_no: uld.uld_no,
                location: uld.location,
                pcs: pcs,
                rdy: uld.rdy,
              }
            ],
          })
        } else {
          awb?.inbound ? awbsIn[index].location = [...new Set(awbsIn[index]?.location?.split(',').concat(awb?.location?.split(',')))].filter(Boolean).join(',') : {}
          awbsIn[index].pcs += pcs
          awbsIn[index].ids.push(awb.id)
          awbsIn[index].wgt.value += awb?.wgt?.value || 0
          awbsIn[index].vol.value = parseFloat(awb?.awb?.vol_pcs || 0) * parseInt(awbsIn[index].pcs || 0)
          awbsIn[index].ch_wgt.value = parseFloat(awb?.awb?.ch_pcs || 0) * parseInt(awbsIn[index].pcs || 0)
          awbsIn[index].at_stn = [...awbsIn[index].at_stn, {
            blk: uld?.blk || false,
            uld_no: uld.uld_no,
            location: uld.location,
            pcs: pcs,
            rdy: uld.rdy,
          }]
          awbsIn[index].spl_code = [...new Set(awbsIn[index]?.spl_code?.split(',').concat(awb.spl_code?.split(',')))].join(',')
        }
      }
    })
  })

  data.awb_segments && data.awb_segments.map(segment => {
    const pre_build = segment.space.ldc || segment.space.ldp || segment.space.udp ? true : false
    const index = awbsIn.findIndex(x => x.awb_no === segment.awb_no)
    if (index == -1) {
      awbsIn.push({
        // remove duplicates flights and then join
        location: [
          ...new Set(
            segment?.segs_outs
              ?.filter(seg => seg.flights_in?.flight_no && seg.flights_in?.flight_date)
              ?.map(seg =>
                seg.location || `${seg.flights_in.flight_no}/${moment(seg.flights_in.flight_date).format(dateOnly)}`
              )
          )
        ].join(', '),
        is_booked: true,
        awb_no: segment.awb_no,
        awb_id: segment.awb_id,
        pcs: segment.space.pcs,
        total_pcs: segment.awb?.pcs?.total?.value || segment.space.pcs,
        avl_pcs: segment.space.pcs,
        wgt: {
          unit: segment.awb?.weight_unit,
          value: segment.space.wgt
        },
        vol: {
          value: segment.awb?.vol_pcs * segment.space.pcs,
          unit: segment.awb?.vol_unit
        },
        org: segment.awb?.org,
        dest: segment.awb?.dest,
        prod_code: segment.awb?.prod_code,
        spl_code: segment.awb?.spl_code,
        on_hand: false,
        pre_build: pre_build,
        // ch_vol,
        ch_wgt: {
          unit: segment.awb?.weight_unit,
          value: segment.awb?.ch_pcs * segment.space.pcs
        },
        comment: segment.allotment,
        showred: segment.showred ? true : false,
        pri: priorityData?.find(x => x.p_code == segment.awb.prod_code)?.priority || null,
        sort_priority: priorityData?.find(x => x.p_code == segment.awb.prod_code)?.sort_priority || null,
        delay: segment.awb.time_of_avl ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment.utc(segment.awb.time_of_avl).tz(cookies.get('timezone')), 'days') : 0,
        booked: [{
          flight_no: data.flight_no,
          flight_date: data.flight_date,
          pcs: segment.space.pcs,
        }],
      })
    } else {
      awbsIn[index].pre_build = pre_build
      awbsIn[index].is_booked = true
      segment?.segs_outs?.map(seg => {
        if (!awbsIn[index].ids?.includes(seg.id)) {
          seg.inbound ? awbsIn[index].location = [...new Set(awbsIn[index]?.location?.split(',').concat(seg.location?.split(',') || [`${seg.flights_in.flight_no}/${moment(seg.flights_in.flight_date).format(dateOnly)}`]))].filter(Boolean).join(',') : {}
          awbsIn[index].ids.push(seg.id)
          awbsIn[index].pcs += seg.avl_pcs || 0
          awbsIn[index].wgt.value += seg.wgt.value || 0
          awbsIn[index].vol.value += (segment.awb?.vol_pcs || 0) * (seg.avl_pcs || 0)
          awbsIn[index].ch_wgt.value += (segment.awb?.ch_pcs || 0) * (seg.avl_pcs || 0)
          awbsIn[index].at_stn = [...awbsIn[index].at_stn, {
            blk: true,
            location: seg.location,
            pcs: seg.avl_pcs,
            rdy: true,
          }]
          awbsIn[index].spl_code = [...new Set(awbsIn[index]?.spl_code?.split(',').concat(segment.awb.spl_code?.split(',') || []))].join(',')
        }
      })
    }
  })
  let icargo = data.build_plan?.filter(awb => awb?.icargo) || false
  if(icargo.length > 0) {
    let oldAwbs = [...awbsIn || []]
    awbsIn = []
    data.build_plan.map(awb => {
      let oldAwb = oldAwbs.find(x => x.awb_no === awb.awb_no)
      let location = awb?.data?.location || oldAwb?.location || ''
      let delay = awb?.data?.delay || oldAwb?.delay || 0
      awbsIn.push({
        ...awb,
        ...awb.data,
        wgt: {
          value: awb?.data?.wgt,
          unit: awb?.data?.wgt_unit
        },
        vol: {
          value: awb?.data?.vol,
          unit: awb?.data?.vol_unit
        },
        total_pcs: awb?.data?.pcs,
        ch_wgt: {
          value: awb?.data?.ch_wgt,
          unit: awb?.data?.wgt_unit
        },
        pri: awb?.data?.pri && parseInt(awb.data.pri) == awb.data.pri ? awb?.data?.pri : priorityData?.find(x => x.p_code == awb?.data?.prod_code)?.priority || null,
        location: location,
        delay: delay,
        sort_priority: awb?.data?.pri && parseInt(awb.data.pri) == awb.data.pri ? awb?.data?.pri : priorityData?.find(x => x.p_code == awb?.data?.prod_code)?.sort_priority || null
      })
    })
  }else
  {
    data.build_plan?.map(awb => {
      const index = awbsIn.findIndex(x => x.awb_no === awb.awb_no)
      if (index == -1 && awb.manual) {
        awbsIn.push({
          ...awb,
          ...awb.data,
          wgt: {
            value: awb?.data?.wgt,
            unit: awb?.data?.wgt_unit
          },
          vol: {
            value: awb?.data?.vol,
            unit: awb?.data?.vol_unit
          },
          total_pcs: awb?.data?.pcs,
          ch_wgt: {
            value: awb?.data?.ch_wgt,
            unit: awb?.data?.wgt_unit
          },
          sort_priority: awb?.data?.pri && parseInt(awb.data.pri) == awb.data.pri ? awb?.data?.pri : priorityData?.find(x => x.p_code == awb?.data?.prod_code)?.sort_priority || null
        })
      } else {
        if (index != -1) {
          awbsIn[index].is_deleted = awb.is_deleted
          awbsIn[index] = {
            ...awbsIn[index],
            ...awb?.data,
            location: awb?.data?.location || awbsIn[index].location,
            dest: awb?.data?.dest || awbsIn[index].dest,
            prod_code: awb?.data?.prod_code || awbsIn[index].prod_code,
            spl_code: awb?.data?.spl_code || awbsIn[index].spl_code,
            pri: awb?.data?.pri && parseInt(awb.data.pri) == awb.data.pri ? awb?.data?.pri : awbsIn[index].pri,
            sort_priority: awb?.data?.pri && parseInt(awb.data.pri) == awb.data.pri ? awb?.data?.pri : awbsIn[index].sort_priority,
            wgt: awbsIn[index].wgt,
            vol: awbsIn[index].vol,
            ch_wgt: awbsIn[index].ch_wgt,
            comment: awb?.data?.comment || awbsIn[index].comment,
          }
          if (awb?.data?.wgt && awb?.data?.wgt > 0)
            awbsIn[index].wgt = {
              value: awb.data.wgt,
              unit: awb.data.wgt_unit
            }
          if (awb?.data?.vol && awb?.data?.vol > 0)
            awbsIn[index].vol = {
              value: awb.data.vol,
              unit: awb.data.vol_unit
            }
          if (awb?.data?.ch_wgt)
            awbsIn[index].ch_wgt = {
              value: awb.data.ch_wgt,
              unit: awb.data.wgt_unit
            }
        }
      }
    })
  }

  let initmergeEditRecord = data.init_build_plan?.data?.mergeEditRecord || []
  let finalmergeEditRecord = data.final_build_plan?.data?.mergeEditRecord || []
  return ({
    mergeEditRecord: awbsIn,
    initmergeEditRecord: initmergeEditRecord,
    finalmergeEditRecord: finalmergeEditRecord,
  })
}

export default getAwbs


